<template>
  <div class="details-wrapper">
    <div class="header">
      <div class="arrow-wrapper">
        <i class="fas fa-arrow-left" id="arrow" @click="$router.back()"></i>
      </div>
      <div id="heading">
        <h1>
          <b>{{ title }}</b>
        </h1>
      </div>
      <div id="community">
        <h5 @click="communityNameHandler">{{ communityName }}</h5>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  data() {
    return {
      communityName: this.$store.getters.getCommunityName
    };
  },
  computed: {
    ...mapState('ticket', ['basicInfo']),
    title() {
      return this.$store.getters.getPostTitle;
    }
  },
  methods: {
    communityNameHandler() {
      this.$router.push({
        name: 'community',
        params: {
          id: this.$store.getters.getActiveCommunity.community_id
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.details-wrapper {
  padding: 10px;
  height: 100%;
  max-height: 100%;
  margin-right: 10px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.header {
  display: flex;
  position: relative;
  height: 64px;
  align-items: center;
  width: 100%;
  // padding-top: 25px;
  padding-top: 10px;
  margin-bottom: 20px;
}

#heading {
  // position: absolute;
  // width: 100%;
  text-align: center;
  z-index: -1;
  margin-top: 15px;
  flex: 4;
  h1 {
    // margin: 0 250px;
  }
}

.arrow-wrapper {
  flex: 2;
}

#arrow {
  position: relative;
  padding: 5px;
  left: 0;
  cursor: pointer;
  border-radius: 50%;
  transition: background-color 0.25s;
  font-size: 2.5rem;
  i {
    z-index: 1;
  }
}

#arrow:hover {
  background-color: rgba(176, 178, 178, 0.5);
}

#community {
  flex: 2;
  right: 0;
  padding-top: 10px;
  // position: absolute;
  text-align: right;
  h5,
  h6 {
    display: inline-block;
  }
  h6 {
    color: #636363;
  }

  h5 {
    transition: color 0.25s;
  }

  h5:hover {
    color: var(--primary-color);

    cursor: pointer;
  }
}
</style>
